import { Component, output } from '@angular/core'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { RouterLink } from '@angular/router'
import { NgxPermissionsModule } from 'ngx-permissions'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'sf-sidebar-starter-footer',
    imports: [FontAwesomeModule, NgbTooltipModule, RouterLink, NgxPermissionsModule],
    template: `
        <div class="sidebar-starter-nav">
            <div class="d-flex flex-column gap-4">
                <a
                    *ngxPermissionsOnly="['ADMIN']"
                    ngbTooltip="View admin settings"
                    container="body"
                    class="d-flex justify-content-center sidebar-starter-nav-link"
                    routerLink="/admin">
                    <fa-icon icon="cog" size="xl"></fa-icon>
                </a>
                <a
                    ngbTooltip="Logout"
                    container="body"
                    class="d-flex justify-content-center sidebar-starter-nav-link"
                    (click)="logout.emit()">
                    <fa-icon icon="arrow-right-from-bracket" size="xl"></fa-icon>
                </a>
            </div>
        </div>
    `,
    host: {
        class: 'sidebar-starter-footer',
    },
})
export class SidebarStarterFooterComponent {
    logout = output()
}
